import React from 'react'
import styles from './ResidentStatusField.module.css'
import { ResidentStatusFieldProps } from './types'
import { RESIDENT_STATUS_OPTIONS } from './options'

export const ResidentStatusField = ({
    value,
    onChange,
    dataViewLabel,
    dataClickLabel,
}: ResidentStatusFieldProps) => {
    const wrapperProps = dataViewLabel ? { 'data-view-label': dataViewLabel } : {}
    const selectProps = dataClickLabel ? { 'data-click-label': dataClickLabel } : {}

    return (
        <div className={styles.wrapper} {...wrapperProps}>
            <p className={styles.title}>外国籍の方のみご入力ください</p>
            <label htmlFor='residentStatus' className={styles.label}>
                現在の在留資格(ビザ)
                <span className={styles.optionalTag}>任意</span>
            </label>
            <select
                id='residentStatus'
                className={`${styles.select}${value ? ` ${styles.selected}` : ''}`}
                value={value}
                onChange={e => onChange(e.target.value)}
                {...selectProps}
            >
                <option value=''>選択</option>
                {RESIDENT_STATUS_OPTIONS.map(option => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
    )
}
